import {
  applyHubspotCookieBannerDialogAccessibility,
  getVisibleHubspotCookieBanner,
  trapFocusWithinHubspotBanner,
} from '@/utils/applyHubspotCookieBannerDialogAccessibility';
import { useEffect } from 'react';

interface UseHubspotCookieBannerDialogA11yParams {
  bannerId?: string;
  dialogTitle?: string;
}

export const useHubspotCookieBannerDialogA11y = ({
  bannerId = 'hs-eu-cookie-confirmation',
  dialogTitle = 'Cookie notice',
}: UseHubspotCookieBannerDialogA11yParams = {}) => {
  useEffect(() => {
    const syncBanner = () => {
      const banner = getVisibleHubspotCookieBanner(bannerId);
      if (banner) {
        applyHubspotCookieBannerDialogAccessibility(banner, { dialogTitle });
      }
    };

    syncBanner();

    const mutationObserver = new MutationObserver(syncBanner);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden'],
    });

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Tab') return;
      const banner = getVisibleHubspotCookieBanner(bannerId);
      if (!banner) return;
      trapFocusWithinHubspotBanner(banner, event);
    };

    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      mutationObserver.disconnect();
    };
  }, [bannerId, dialogTitle]);
};
